import React from 'react';
import { Typography } from '@mui/material';
import { InformedConsentStatusChip } from '@/components/InformedConsentStatusChip';
import { CONSENT_STATUS, getRowConsentStatus } from '@/features/informedConsent/helpers';

const DataGridInformedConsent = (row) => {
	const status = getRowConsentStatus(row);

	if (!status || status === CONSENT_STATUS.NONE) {
		return <Typography variant='inherit'>—</Typography>;
	}

	return <InformedConsentStatusChip status={status} />;
};

export default DataGridInformedConsent;
